export default __webpack_public_path__ + "static/media/b4.dddb0732.jpg";